import axios from 'axios'

export const byLocation = (lat, lng) =>
    axios.get('events/list_experiences/0/12', {lat, lng})
    
export const filter = (filter, limit = 20) =>
    axios.get(`events/list_experiences/0/${limit}?filter=${filter}`)


// WEBPACK FOOTER //
// ./src/utils/experiences.js